import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, PROFILE } from "../data/content";

export const ProNav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
          scrolled ? "bg-white/85 backdrop-blur border-b border-neutral-200" : "bg-transparent"
        }`}
        data-testid="pro-header"
      >
        <div className="max-w-6xl mx-auto flex items-center justify-between px-5 md:px-8 h-16">
          <Link
            to="/"
            className="font-plex font-medium text-lg tracking-tight text-neutral-900"
            data-testid="pro-nav-logo"
          >
            {PROFILE.fullName || PROFILE.name}
          </Link>

          <nav className="hidden md:flex items-center gap-7">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`pro-nav-link-${link.label.toLowerCase()}`}
                className={`font-plex text-sm transition-colors duration-200 ${
                  location.pathname === link.path
                    ? "text-neutral-900 font-medium"
                    : "text-neutral-500 hover:text-neutral-900"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <button
            className="md:hidden text-neutral-900"
            onClick={() => setOpen(true)}
            data-testid="pro-nav-menu-open"
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>
        </div>
      </header>

      {open && (
        <div
          className="fixed inset-0 z-[60] bg-white flex flex-col animate-in fade-in"
          data-testid="pro-mobile-menu"
        >
          <div className="flex items-center justify-between px-5 h-16 border-b border-neutral-200">
            <span className="font-plex font-medium text-lg">{PROFILE.fullName || PROFILE.name}</span>
            <button onClick={() => setOpen(false)} aria-label="Close menu">
              <X size={22} />
            </button>
          </div>
          <nav className="flex flex-col p-6 gap-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="font-plex text-2xl py-3 border-b border-neutral-100 text-neutral-900"
                data-testid={`pro-mobile-nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </>
  );
};
